import { FaLinkedin, FaEnvelope } from "react-icons/fa";
import logo from "../assets/saas.png"

export default function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div>
          <img src={logo} alt="Ellentra team"/>
          <h3>Ellentra Technologies</h3>
          <p>
            Building digital solutions that empower growth, innovation, and
            long-term success.
          </p>
        </div>

        <div className="footer-links">
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#contact">Contact</a>
        </div>

        <div className="footer-socials">
          <a href="#https://www.linkedin.com/company/ellentra-technologies/?viewAsMember=tru"><FaLinkedin /></a>
          <a href="mailto:info@ellentra.co.za"><FaEnvelope /></a>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Ellentra Technologies. All rights reserved.
      </div>
    </footer>
  );
}
